import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PlanningViewSettingsDraftColumnsModel} from "../../models/planning-view-settings.model";

export class PlanningDraftOverviewCtrl implements IController {
  project: any;
  draft: any;
  columns: PlanningViewSettingsDraftColumnsModel;
  settings: any;
  isLean: boolean;

  private weightUnit: any;
  private distanceUnit: any;
  private currencyUnit: any;
  private conflicts: any;


  onApprove: Function;
  onDelete: Function;

  /* @ngInject */
  constructor(private splitService) {
    this.weightUnit = this.splitService.getWeightUnit();
    this.distanceUnit = this.splitService.getSiteDistanceSmallUnit();
    this.currencyUnit = this.splitService.getCurrencySymbol();
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.draft) {
      this.conflicts = this.draft && _.get(this.draft, 'analysis.stopWarnings') ?
        _.size(this.draft.analysis.stopWarnings) : undefined;
    }
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningDraftOverview', {
    bindings: {
      project: '<',
      draft: '<',
      columns: '<?',
      isLean: '<?',
      onApprove: '&',
      onDelete: '&'
    },
    template: require('./planning-draft-overview.html').default,
    controller: PlanningDraftOverviewCtrl
  });
